import Translate from '@/docs-partials/api/endpoints/translate.mdx';
import * as React from 'react';
export default {
  Translate,
  React
};